import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { setInitialStoreState } from '../../../../../common/utils';
import { MasterDataType } from '../constants';
import { MasterDataReportItemFacade } from './master-data-report-item.facade';

@Injectable({
  providedIn: 'root',
})
export class MasterDataReportItemGuard {
  constructor(private masterDataReportItemFacade: MasterDataReportItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { id },
      data: { type },
    } = route;

    this.masterDataReportItemFacade.setReportInitData(id, type ?? MasterDataType.Address);

    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.masterDataReportItemFacade);
  }
}
